import { render, staticRenderFns } from "./SettingsMobile.vue?vue&type=template&id=5251697c&scoped=true&"
import script from "./SettingsMobile.vue?vue&type=script&lang=js&"
export * from "./SettingsMobile.vue?vue&type=script&lang=js&"
import style0 from "vue-tel-input/dist/vue-tel-input.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./SettingsMobile.vue?vue&type=style&index=1&id=5251697c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5251697c",
  null
  
)

export default component.exports